import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useApp } from '../../AppContext';

const MobileContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  position: relative;
`;

const MobileContent = styled.main`
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  padding-top: 1.9rem; /* 상단 필터 버튼 공간 */
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
`;

const FilterBar = styled.div`
  position: fixed;
  top: 65px; /* 네비게이터 아래 */
  left: 0;
  right: 0;
  width: 100%
  max-width: 100%;
  padding: 0.4rem;
  margin: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 9999;
  box-sizing: border-box;
`;

const FilterButton = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
  }
  
  .text {
    font-weight: 500;
  }
  
  .arrow {
    font-size: 1.2rem;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
  }
`;

const DropdownOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const DropdownMenu = styled.div`
  position: fixed;
  top: 130px; /* FilterBar 아래 */
  left: 1rem;
  right: 1rem;
  max-height: 60vh;
  background: rgba(30, 60, 114, 0.95);
  backdrop-filter: blur(15px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  z-index: 10001;
  overflow-y: auto;
  transform: ${props => props.isOpen ? 'translateY(0) scale(1)' : 'translateY(-20px) scale(0.95)'};
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const DropdownHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  
  h3 {
    color: white;
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
`;

const DropdownSection = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  
  &:not(:last-child) {
    border-bottom: 1px solid #e9ecef;
  }
`;

const SectionTitle = styled.h4`
  color: #6c757d;
  margin: 0;
  padding: 0.5rem 0.75rem 0.25rem 0.75rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8f9fa;
`;

const DropdownItem = styled.div`
  padding: 0.75rem 1rem;
  color: ${props => props.active ? 'dodgerblue' : 'white'};
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => props.active ? 'rgba(30, 144, 255, 0.2)' : 'transparent'};
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: dodgerblue;
  }
  
  .label {
    font-size: 0.95rem;
    font-weight: 500;
  }
`;

const QuickMenu = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  backdrop-filter: blur(15px);
  margin-bottom: 1rem;
`;

const QuickMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
    border-color: dodgerblue;
  }
  
  .icon {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #fff;
  }
  
  .label {
    font-size: 0.9rem;
    color: #fff;
    text-align: center;
    font-weight: 500;
  }
`;

const BottomNav = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 9991;
`;

const BottomNavItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${props => props.active ? 'dodgerblue' : 'rgba(255, 255, 255, 0.8)'};
  transition: all 0.3s ease;
  
  &:hover {
    color: dodgerblue;
  }
  
  .icon {
    font-size: 1.5rem;
    margin-bottom: 0.2rem;
  }
  
  .label {
    font-size: 0.7rem;
    font-weight: 500;
  }
`;

const MobileHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useApp();
  
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [links, setLinks] = useState([]);

  // 정적 링크 (데스크톱 버전과 동일)
  const staticLinks = [
    { path: '/StatisticList', label: '대시보드' },
    { path: '/BoardAdmin', label: '메뉴관리' },
    { path: '/StandardInfo', label: '기준정보 관리' },
    { path: '/StandardInfo_Dtail', label: '기준정보 상세' },
    { path: '/SystemGuide', label: '시스템 메뉴얼' },
    { path: '/OrganizationManagement', label: '권한관리' },
  ];

  // 동적 링크 가져오기
  useEffect(() => {
    const fetchBoardTables = async () => {
      try {
        const response = await fetch('/request/getBoardTables?category=root', { credentials: 'include' });
        const data = await response.json();
        
        const dynamicLinks = data.map(table => ({
          path: `/Board/${table.boardId}`,
          label: table.boardTitle
        }));
        
        setLinks([...staticLinks, ...dynamicLinks]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
        setLinks(staticLinks);
      }
    };
    
    fetchBoardTables();
  }, []);

  const quickMenuItems = [];

  const bottomNavItems = [];

  const handleNavigate = (path, state = null) => {
    navigate(path, { state });
    setDropdownOpen(false); // 네비게이션 후 드롭다운 닫기
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  // 링크를 섹션별로 분류
  const basicLinks = links.filter(link => 
    ['/StatisticList', '/BoardAdmin', '/StandardInfo', '/StandardInfo_Dtail', '/SystemGuide', '/OrganizationManagement'].includes(link.path)
  );
  
  const boardLinks = links.filter(link => link.path.startsWith('/Board/'));

  // MobileSubNavigator를 사용하는 페이지에서는 FilterBar 숨김
  const mobileSubNavPaths = ['/BoardAdmin', '/StandardInfo', '/StandardInfo_Dtail', '/StatisticList', '/OrganizationManagement', '/SystemGuide', '/ControlInfo'];
  const shouldHideFilterBar = mobileSubNavPaths.includes(location.pathname);
  
  // 현재 활성화된 메뉴 찾기
  const activeLink = links.find(link => location.pathname === link.path);
  const displayText = activeLink ? activeLink.label : '홈 메뉴 선택';

  return (
    <MobileContainer>
      {/* 상단 필터 바 - MobileSubNavigator 페이지에서는 숨김 */}
      {!shouldHideFilterBar && (
        <FilterBar>
          <FilterButton isOpen={dropdownOpen} onClick={toggleDropdown}>
            <span className="text">{displayText}</span>
            <span className="arrow">▼</span>
          </FilterButton>
        </FilterBar>
      )}

      {/* 드롭다운 오버레이 - MobileSubNavigator 페이지에서는 숨김 */}
      {!shouldHideFilterBar && (
        <>
          <DropdownOverlay isOpen={dropdownOpen} onClick={closeDropdown} />
      
      {/* 드롭다운 메뉴 */}
      <DropdownMenu isOpen={dropdownOpen}>
        <DropdownHeader>
          <h3>홈 메뉴</h3>
        </DropdownHeader>
        
        {basicLinks.length > 0 && (
          <DropdownSection>
            <SectionTitle>기본 메뉴</SectionTitle>
            {basicLinks.map((link, index) => (
              <DropdownItem
                key={index}
                active={location.pathname === link.path}
                onClick={() => handleNavigate(link.path)}
              >
                <div className="label">{link.label}</div>
              </DropdownItem>
            ))}
          </DropdownSection>
        )}
        
        {boardLinks.length > 0 && (
          <DropdownSection>
            <SectionTitle>게시판</SectionTitle>
            {boardLinks.map((link, index) => (
              <DropdownItem
                key={index}
                active={location.pathname === link.path}
                onClick={() => handleNavigate(link.path)}
              >
                <div className="label">{link.label}</div>
              </DropdownItem>
            ))}
          </DropdownSection>
        )}
      </DropdownMenu>
        </>
      )}

      <MobileContent>
        {quickMenuItems.length > 0 && (
          <QuickMenu>
            {quickMenuItems.map((item, index) => (
              <QuickMenuItem 
                key={index}
                onClick={() => handleNavigate(item.path, item.state)}
              >
                <div className="icon">{item.icon}</div>
                <div className="label">{item.label}</div>
              </QuickMenuItem>
            ))}
          </QuickMenu>
        )}
        
        <Outlet />
      </MobileContent>
      
      {bottomNavItems.length > 0 && (
        <BottomNav>
          {bottomNavItems.map((item, index) => (
            <BottomNavItem
              key={index}
              onClick={() => handleNavigate(item.path)}
              active={location.pathname === item.path}
            >
              <div className="icon">{item.icon}</div>
              <div className="label">{item.label}</div>
            </BottomNavItem>
          ))}
        </BottomNav>
      )}
    </MobileContainer>
  );
};

export default MobileHome;